import axios from 'axios';

export const fetchMitigationData = async ({
    area,
    selectedValue,
    height,
    getModelNumber,
    props,
    setMitigationZoneData,
    setPrevArea,
    setState,
    settings,
    threeModel
}) => {
    const validArea = area > 0 ? area : 0;
    const huburl = settings.service_url;
    const mitigationRequestData = [];

    if (['R-455A', 'R-454A', 'R-454C'].includes(selectedValue)) {
        if (height && (validArea || validArea === 0) && parseFloat(height) >= 5.0) {
            if (getModelNumber && getModelNumber.length > 0 && (validArea || validArea === 0)) {
                for (const materialKey of getModelNumber) {
                    if (materialKey.length >= 8 && materialKey[8].toLowerCase() === 'y' && threeModel === false) {
                        const cleanedSelectedValue = selectedValue.replace(/-/g, '');
                        mitigationRequestData.push({
                            materialNumber: materialKey,
                            refrigerant: cleanedSelectedValue,
                            sst: "25", 
                            height: height.toString(),
                            roomArea: validArea.toString(),
                            uomLength: 'ft',
                        });
                    }
                }

                if (mitigationRequestData.length > 0) {
                    try {
                        const mitigationResponse = await axios.post(
                            settings.is_hub ? `/heatcraftwebservices/v2/heatcraft/a2l/product/mitigationzones` : `${huburl}/heatcraftwebservices/v2/heatcraft/a2l/product/mitigationzones`,
                            { mitigationRequestData }
                        );
                        
                        if (mitigationResponse && mitigationResponse.data) {
                            const responseArray = mitigationResponse.data; 
                            setMitigationZoneData(responseArray);

                            if (responseArray.length > 0) {
                                props.update('aMin', responseArray[0].minRoomArea);
                                props.update('zone', responseArray[0].zone);
                            }
                        }
                    } catch (error) {
                        console.error('Error in mitigationzone API call', error);
                    } finally {
                        setPrevArea(area);
                        setState(prevState => ({ ...prevState, loader: false }));
                    }
                } else {
                    setMitigationZoneData([]);
                    props.update('aMin', null);
                    props.update('zone', null);
                    setState(prevState => ({ ...prevState, loader: false }));
                }
            } else {
                setMitigationZoneData([]);
                props.update('aMin', null);
                props.update('zone', null);
                setState(prevState => ({ ...prevState, loader: false }));
            }
        } else {
            setMitigationZoneData([]);
            props.update('aMin', null);
            props.update('zone', null);
            setState(prevState => ({ ...prevState, loader: false }));
        }
    } else {
        setMitigationZoneData([]);
        props.update('aMin', null);
        props.update('zone', null);
        setState(prevState => ({ ...prevState, loader: false }));
    }
};